<template>
    <div class="search bg-fff">
        <div class="editor bg-fff">
            <i class="iconfont icon-search"></i>
            <input type="text" ref="searchBox" v-model="words" @keyup="keyup($event)" @input="searchInput"
                    placeholder="关键词进行搜索">
        </div>
        <div class="clear-icon icon-div" v-if="showClear" @click="clear">
            <i class="iconfont icon-close" style="font-size:13px;"></i>
        </div>
    </div>
</template>
<style scoped>
    .search {
        background-color: #fff;
        /*width: 382px;*/
    }
    .search .icon-search{
        font-size:16px;
        color: #6C6F70
    }
    .search .editor {
        font-size: 12px;
        width: 400px;
        padding: 4px 10px;
        height: 32px;
        text-align: left;
        border-radius: 100px;
        float: left;
        margin-top: 4px;
    }

    .search .editor input {
        display: inline-block;
        font-size: 12px;
        width: 356px;
        height: 100%;
        /*float: right;*/
        color: #A2A2A8;
        margin-right: 5px;
        background: transparent;
    }

    .search .editor input::-webkit-input-placeholder { /* WebKit browsers */
        font-size: 12px;
        color: #A2A2A8;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .search .editor input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        font-size: 12px;
        color: #A2A2A8;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .search .editor input::-moz-placeholder { /* Mozilla Firefox 19+ */
        font-size: 12px;
        color: #A2A2A8;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .search .editor input:-ms-input-placeholder { /* Internet Explorer 10+ */
        font-size: 12px;
        color: #A2A2A8;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .search .editor input,
    .search .editor input:focus,
    .search .editor input:hover {
        border: 0 none;
        outline: none;
        box-shadow: none;
    }

    .search .icon-div {
        width: 23px;
        display: inline-block;
        margin-top: -25px;
        float: right;
        margin-right: -168px;
        vertical-align: middle;
    }

    .search .icon-div .ivu-btn {
        padding: 0;
        border: 0;
        display: block;
    }

    .search .icon-div .ivu-btn-text:hover {
        color: #111;
    }
</style>
<script>
    export default{
        props: {
            keyword: {
                type: String,
                default: ''
            }
        },
        data(){
            return {
                words: this.keyword,
                showClear: this.keyword?true:false
            }
        },
        methods: {
            clear(){
                this.words = '';
                this.$emit('search', '', this.words);
                this.showClear = false;
            },
            keyup(e){
                if(this.words.trim() == ''){
                    if(this.showClear){
                        this.clear();
                    }
                    return;
                }
                if (e.key == 'Enter'||e.keyCode == 13) {
                    this.search();
                }
            },
            search(){
                this.words = this.words.trim();
                if(this.words){
                    this.showClear = true;
                    this.$emit('search', this.words.trim());
                }
            },
            searchInput(){
                if(this.words.length>20){
                    this.words = this.words.slice(0,20);
                }
            },
            resetSearch(){
                this.words = '';
                this.showClear = false;
                this.$emit('search', 'keyword', this.words);
            }
        },
        mounted(){
            this.$refs.searchBox.focus();
        }
    }
</script>